import LearnBoard from "../../../assets/learnboard.webp"
import { Link } from "react-scroll";

const LearnServices = () => {
    return (
        <div className="learn-services-container">
            <img src={LearnBoard} alt="Learn Service" />
            <div className="learn-inner">
                <h3>Are you ready to learn more about our services?</h3>
                <p>Schedule a discovery call with us to discuss your needs and how we can help you achieve your goals.</p>
                <Link to={"schedule"} spy={true} smooth={true} offset={-100} duration={2000} >
                    <button type="button">Schedule a Call</button>
                </Link>
            </div>
        </div>
    )
}

export default LearnServices